module.exports = __webpack_public_path__ + "img/4.2.b3b3d181.png";